import React from 'react';
import Icon from './Icon';

const TextIcon = (props) => (
    <Icon {...props}>
        <path d="M8 4V20M17 12V20M6 20H10M15 20H19M13 7V4H3V7M21 14V12H13V14" />
    </Icon>
);

export default TextIcon;
